import ITTIModel from '../../ittijs/ITTIModel';
export default class extends ITTIModel {
  constructor() {
    super('SessionTemplates');
  }
  getByUtility(utility){
    return this.fetch('getByUtility', {utility});
  }
}